import { de_CreateEditorSessionCommand, se_CreateEditorSessionCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
/**
 * Create a new editor session for an assignment
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { Apiv2Client, CreateEditorSessionCommand } from "@codegrade/apiv2-client"; // ES Modules import
 * // const { Apiv2Client, CreateEditorSessionCommand } = require("@codegrade/apiv2-client"); // CommonJS import
 * const client = new Apiv2Client(config);
 * const input = { // CreateEditorSessionRequest
 *   assignmentId: "STRING_VALUE", // required
 *   name: "STRING_VALUE", // required
 *   owner: "STRING_VALUE", // required
 *   source: { // EditorSessionSource Union: only one key present
 *     template: {},
 *     submission: { // EditorSessionSubmissionSource
 *       submissionId: "STRING_VALUE", // required
 *     },
 *   },
 * };
 * const command = new CreateEditorSessionCommand(input);
 * const response = await client.send(command);
 * // { // CreateEditorSessionResponse
 * //   editorSession: { // EditorSession
 * //     editorSessionId: "STRING_VALUE", // required
 * //     owner: "STRING_VALUE", // required
 * //     assignmentId: "STRING_VALUE", // required
 * //     name: "STRING_VALUE", // required
 * //     createdAt: new Date("TIMESTAMP"), // required
 * //     updatedAt: new Date("TIMESTAMP"), // required
 * //     fileTreeId: "STRING_VALUE", // required
 * //   },
 * // };
 *
 * ```
 *
 * @param CreateEditorSessionCommandInput - {@link CreateEditorSessionCommandInput}
 * @returns {@link CreateEditorSessionCommandOutput}
 * @see {@link CreateEditorSessionCommandInput} for command's `input` shape.
 * @see {@link CreateEditorSessionCommandOutput} for command's `response` shape.
 * @see {@link Apiv2ClientResolvedConfig | config} for Apiv2Client's `config` shape.
 *
 * @throws {@link InternalServerError} (server fault)
 *  An internal failure at the fault of the server.
 *
 * @throws {@link BadRequestError} (client fault)
 *  An error at the fault of the client sending invalid input.
 *
 * @throws {@link NotFoundError} (client fault)
 *  An error due to the client attempting to access a missing
 * resource.
 *
 * @throws {@link NotAuthorizedError} (client fault)
 *  An error due to the client not being authorized to access the
 * resource.
 *
 * @throws {@link NotAuthenticatedError} (client fault)
 *  An error due to the client not being authenticated.
 *
 * @throws {@link ValidationError} (client fault)
 *  A standard error for input validation failures.
 * This should be thrown by services when a member of the input structure
 * falls outside of the modeled or documented constraints.
 *
 * @throws {@link Apiv2ServiceException}
 * <p>Base exception class for all service exceptions from Apiv2 service.</p>
 *
 *
 * @public
 */
export class CreateEditorSessionCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Apiv2", "CreateEditorSession", {})
    .n("Apiv2Client", "CreateEditorSessionCommand")
    .f(void 0, void 0)
    .ser(se_CreateEditorSessionCommand)
    .de(de_CreateEditorSessionCommand)
    .build() {
}
